import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Iter 57 — Dropdown nama Penandatangan dari Master "/api/signatories".
 * Saat name dipilih, posisi/jabatan ikut ter-set via onPick.
 *
 * Props:
 *  - name (string)        : current selected name
 *  - onPick (fn)          : ({name, position}) => void  — dipanggil saat user pilih opsi
 *  - placeholder?, "data-testid"?
 */
export default function SignatoryPicker({ name, onPick, placeholder, ...rest }) {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    let mounted = true;
    api.get("/signatories").then((r) => { if (mounted) setOpts(r.data || []); }).catch(() => {});
    return () => { mounted = false; };
  }, []);
  const hasCurrent = !name || opts.some((o) => o.name === name);
  return (
    <select
      value={name || ""}
      onChange={(e) => {
        const picked = opts.find((o) => o.name === e.target.value);
        onPick({ name: e.target.value, position: picked?.position || "" });
      }}
      className="w-full border border-stone-300 bg-white px-3 py-2 text-sm focus:border-terra-500 focus:ring-1 focus:ring-terra-500 outline-none"
      {...rest}
    >
      <option value="">{placeholder || "— Pilih Nama —"}</option>
      {!hasCurrent && <option value={name}>{name} (lama)</option>}
      {opts.map((o) => (
        <option key={o.id || o.name} value={o.name}>
          {o.position ? `${o.name} — ${o.position}` : o.name}
        </option>
      ))}
    </select>
  );
}
